import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { CardSection } from 'legacyComponents/layout/cardSection';
import { StoryCard } from 'legacyComponents/cards/types/story';

import { clientStore } from 'apps/client/app';
import { MainWrapper } from 'legacyComponents/styled/lib';

import { FourOhFour } from 'apps/fourOhFour/index';

import { conf } from 'apps/profile/config.yaml';

const ProfileStories = props => {
  const { appManager, t } = props;
  if (appManager.queries.get('profile')?.notFound) {
    return <FourOhFour type='Profile' />;
  }
  const { profile, storiesConn } = appManager;
  const stories = storiesConn.arrayApp;

  const { canUpdate, fullName } = profile;
  const {
    inSpace: { whichTypes },
  } = profile;
  const displayName = fullName.split(' ')[0];

  return (
    <MainWrapper>
      <CardSection
        invisible={appManager.loading}
        title={conf.sections[1]}
        tooltip={t('Create new story')}
        updateHeader={true}
        index={2}
        createHandler={
          whichTypes.includes('Story')
            ? () => clientStore.routerStore.navigate('home.newStory')
            : () => ''
        }
        owner={canUpdate}
        ownerName={displayName}
        cardApp={stories}
        CardComponent={StoryCard}
        noDataCardType='story'
        gridColumns={2}
        canShowNoDataCard
      />
    </MainWrapper>
  );
};

ProfileStories.propTypes = {
  routeName: PropTypes.string,
  params: PropTypes.object,
  t: PropTypes.func,
  appManager: PropTypes.object,
};

export default withNamespaces()(observer(ProfileStories));
